import { Member } from "@/api/members.api";
import { UserAvatar } from "@/components/core/UserAvatar";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { ExtendedListChildComponentProps } from "@/components/core/InfiniteScrollList/VirtualizedList";

interface MemberListCardProps extends ExtendedListChildComponentProps {
  isChargeFlow?: boolean;
}

export function MemberListCard({
  style,
  data,
  isChargeFlow,
  ref,
}: MemberListCardProps) {
  const navigate = useNavigate();

  if (!data) {
    return <div style={style} className="px-4" />;
  }

  const member = data as Member;

  const handleClick = () => {
    if (isChargeFlow) {
      navigate(`/members/${member.id}/charge`);
    } else {
      navigate(`/members/${member.id}`);
    }
  };

  return (
    <div style={style}>
      <Card
        className="hover:bg-accent cursor-pointer transition-colors p-0"
        onClick={handleClick}
        ref={ref}
      >
        <CardContent className="flex items-center gap-4 p-4">
          <UserAvatar
            imageUrl={member.imageUrl}
            name={`${member.firstName} ${member.lastName}`}
          />

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium leading-none truncate">
              {member.firstName} {member.lastName}
            </p>
          </div>

          <ArrowRight className="h-5 w-5 text-muted-foreground ml-auto" />
        </CardContent>
      </Card>
    </div>
  );
}
